import React from 'react';
import TextField from '@mui/material/TextField';
import styles from './index.module.css';

const formatYear = (raw) =>
  String(raw || '')
    .replace(/\D/g, '')
    .slice(0, 4);

const formatMaskedDate = (raw) => {
  const digits = String(raw || '')
    .replace(/\D/g, '')
    .slice(0, 8);
  if (digits.length === 0) return '';
  if (digits.length <= 2) return digits;
  if (digits.length <= 4) return `${digits.slice(0, 2)}/${digits.slice(2)}`;
  return `${digits.slice(0, 2)}/${digits.slice(2, 4)}/${digits.slice(4)}`;
};

const DateInput = ({ value = '', onChange, placeholder = 'MM/DD/YYYY', ariaLabel, yearOnly = false, ...rest }) => {
  const handleChange = (e) => {
    const next = yearOnly ? formatYear(e.target.value) : formatMaskedDate(e.target.value);
    if (typeof onChange === 'function') onChange(next);
  };

  return (
    <TextField
      className={styles.input}
      fullWidth
      variant='outlined'
      placeholder={placeholder}
      value={value}
      onChange={handleChange}
      inputProps={{
        inputMode: 'numeric',
        maxLength: yearOnly ? 4 : 10,
        'aria-label': ariaLabel || placeholder,
      }}
      {...rest}
    />
  );
};

export default DateInput;
